import clsx from 'clsx';
import * as React from 'react';
import { useCallback } from 'react';
import { getChildRef } from '@restart/ui/utils';
import transitionEndListener from './transitionEndListener.js';
import triggerBrowserReflow from './triggerBrowserReflow.js';
import TransitionWrapper from './TransitionWrapper.js';
import { jsx as _jsx } from "react/jsx-runtime";
const fadeStyles = {
  entering: 'show',
  entered: 'show'
};
const Fade = /*#__PURE__*/React.forwardRef(({
  className,
  children,
  transitionClasses = {},
  onEnter,
  ...rest
}, ref) => {
  const props = {
    in: false,
    timeout: 300,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    ...rest
  };
  const handleEnter = useCallback((node, isAppearing) => {
    triggerBrowserReflow(node);
    onEnter == null || onEnter(node, isAppearing);
  }, [onEnter]);
  return /*#__PURE__*/_jsx(TransitionWrapper, {
    ref: ref,
    addEndListener: transitionEndListener,
    ...props,
    onEnter: handleEnter,
    childRef: getChildRef(children),
    children: (status, innerProps) => /*#__PURE__*/React.cloneElement(children, {
      ...innerProps,
      className: clsx('fade', className, children.props.className, fadeStyles[status], transitionClasses[status])
    })
  });
});
Fade.displayName = 'Fade';
export default Fade;